import React, { useEffect, useState } from "react";
import alumniApi from "../../config/alumniApi";
import styles from "./AlumniPages.module.css";

const AlumniCommunity = () => {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    alumniApi
      .get("/alumni/social-links")
      .then(({ data }) => setLinks(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1 className={styles.heading}>Community</h1>
      <p className={styles.subheading}>Join your batch and interest groups on social media.</p>

      {loading && <div className={styles.emptyState}>Loading...</div>}
      {!loading && links.length === 0 && (
        <div className={styles.emptyState}>No community links have been added yet.</div>
      )}

      {!loading &&
        links.map((link) => (
          <a
            key={link.social_id}
            href={link.group_url}
            target="_blank"
            rel="noreferrer"
            className={styles.socialLink}
          >
            <strong>{link.group_name}</strong>
            <div className={styles.cardMeta}>{link.platform_name}</div>
          </a>
        ))}
    </div>
  );
};

export default AlumniCommunity;
